import React from 'react'

export default function DeleteModal({ story, inQueue, onCancel, onDelete, onQueue }) {
  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div className="modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 400 }}>
        <div className="modal-header"><h2 className="modal-title">Remove story?</h2></div>
        <p style={{ fontFamily: "'Courier New', monospace", fontSize: '0.9rem', color: '#444', marginBottom: '1.25rem', lineHeight: 1.5 }}>
          "{story.headline}"
        </p>
        <div className="modal-actions" style={{ justifyContent: 'space-between' }}>
          <button className="btn-secondary" onClick={onCancel}>Cancel</button>
          {!inQueue && <button className="btn-secondary" onClick={onQueue}>Move to queue</button>}
          <button className="btn-primary" style={{ background: '#c0392b' }} onClick={onDelete}>Delete</button>
        </div>
      </div>
    </div>
  )
}
